<template>
  <IconLucideCloudUpload />
</template>
